/**
 * 說明 : 電梯資料與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 新增部門資訊
export const addDepartment = createAsyncThunk('department/addDepartment', async (department, {getState, rejectWithValue}) => {
  try {
    const token = getState().auth.token;
    const data = await BaseAPI.postWithAuth('/department', department, token);
    return data;
  } catch (err) {
    console.error('add department error', err.response.data);
    return rejectWithValue(err.response.data);
  }
});

// 修改部門資訊
export const editDepartment = createAsyncThunk('department/editDepartment', async (department, {getState, rejectWithValue}) => {
  try {
    const token = getState().auth.token;
    const data = await BaseAPI.putWithAuth('/department', department, token);
    return data;
  } catch (err) {
    console.error('edit department error', err.response.data);
    return rejectWithValue(err.response.data);
  }
});

// 修改部門狀態
export const editDepartmentStatus = createAsyncThunk(
  'department/editDepartmentStatus',
  async ({departmentCodes, flgStatus}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/department/status', {departmentCodes, flgStatus}, token);
      return data;
    } catch (err) {
      console.error('edit department error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得部門資料
export const fetchDepartment = createAsyncThunk('department/fetchDepartment', async (departmentCode, {getState, rejectWithValue}) => {
  try {
    const token = getState().auth.token;
    const data = await BaseAPI.getWithAuth(`/department/${departmentCode}`, null, token);
    return data;
  } catch (err) {
    console.error('fetch elevator error', err.response.data);
    return rejectWithValue(err.response.data);
  }
});

// 取得部門清單列表
export const fetchDepartmentList = createAsyncThunk('department/fetchDepartmentList', async ({ }, {getState, rejectWithValue}) => {
  try {
    const token = getState().auth.token;
    const data = await BaseAPI.getWithAuth('/department', {}, token);
    return data;
  } catch (err) {
    //   console.error('fetch elevator list error', err.response.data);
    return rejectWithValue(err.response.data);
  }
});

// 取得有效的部門名稱選單
export const fetchDepartmentSelection = createAsyncThunk(
  'department/fetchDepartmentSelection',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/selection/department', null, token);
      return data;
    } catch (err) {
      console.error('fetch department selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
